import { render, staticRenderFns } from "./PorPlano.vue?vue&type=template&id=05d6caf7"
import script from "./PorPlano.vue?vue&type=script&lang=js"
export * from "./PorPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports